export enum VersionStatus {
  Archived = 'archived',
  Draft = 'draft',
  PendingApproval = 'pending_approval',
  Published = 'published',
}
